import { render, staticRenderFns } from "./CertifiedList.vue?vue&type=template&id=8120ac4e&scoped=true&"
import script from "./CertifiedList.vue?vue&type=script&lang=js&"
export * from "./CertifiedList.vue?vue&type=script&lang=js&"
import style0 from "./CertifiedList.vue?vue&type=style&index=0&id=8120ac4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8120ac4e",
  null
  
)

export default component.exports